import React, { useState, useEffect } from 'react';
import './Taskupdate.css';

const TaskUpdateForm = () => {
  // State variables for task update form
  const [empId, setEmpId] = useState('');
  const [empName, setEmpName] = useState('');
  const [designation, setDesignation] = useState('');
  const [projectName, setProjectName] = useState('');
  const [taskName, setTaskName] = useState('');
  const [taskHours, setTaskHours] = useState('00:00:00');
  const [hoursWorked, setHoursWorked] = useState('00:00:00');
  const [projectStatus, setProjectStatus] = useState('');
  const [comments, setComments] = useState('');
  const [statusMessage, setStatusMessage] = useState({ type: '', text: '' });

  const [surplusHours, setSurplusHours] = useState('00:00:00');
  const [overHours, setOverHours] = useState('00:00:00');
  const [hoursLeft, setHoursLeft] = useState('00:00:00');
  const [taskAssigned, setTaskAssigned] = useState(true);
  const [startTime, setStartTime] = useState('00:00:00');
  const [endTime, setEndTime] = useState('00:00:00');

  const [pendingTasks, setPendingTasks] = useState([])
  const [selectedTask, setSelectedTask] = useState("");



  // Fetch employee data from localStorage on mount
  useEffect(() => {
    const storedEmpId = localStorage.getItem('empId');
    const storedEmpName = localStorage.getItem('empName');
    const storedDesignation = localStorage.getItem('designation');
    if (storedEmpId && storedEmpName && storedDesignation) {
      setEmpId(storedEmpId);
      setEmpName(storedEmpName);
      setDesignation(storedDesignation);
    } else {
      setStatusMessage({ type: 'error', text: 'Session expired. Please log in again.' });
      setTimeout(() => {
        window.location.href = '/login';
      }, 2000);
    }

  }

    , []);

  // Fetch task details whenever empId changes
  useEffect(() => {
    if (empId) {
      fetchRecentTaskDetails(empId);
      fetchPendingTasks(empId)
    }
  }, [empId]);

  const fetchPendingTasks = (empId) => {
    fetch(`https://cleezoclass.com:8443/api/task_names?assignto=${empId}`)
      // fetch(`https://cleezoclass.com:8443/api/task_names?assignto=${encodeURIComponent(empId)}`)

      .then((response) => response.json())
      .then((data) => {
        setPendingTasks(data);
        if (data.length > 0) {
          setSelectedTask(data[0].addtask); // Automatically select the first task
          setProjectName(data[0].projecttitle); // Set the project name for the first task
        } else {
          setSelectedTask(""); // Reset if no tasks available
          setProjectName(""); // Reset project name
        }
      })
      .catch((error) => console.error("Error fetching tasks:", error));
  };

  // Calculate surplus, over, and left hours
  useEffect(() => {
    if (taskHours && hoursWorked) {
      const taskSeconds = convertTimeToSeconds(taskHours);
      const workedSeconds = convertTimeToSeconds(hoursWorked);
      const surplus = taskSeconds - workedSeconds;
      const over = workedSeconds - taskSeconds;
      const left = taskSeconds - workedSeconds;
      setSurplusHours(formatTime(surplus > 0 ? surplus : 0));
      setOverHours(formatTime(over > 0 ? over : 0));
      setHoursLeft(formatTime(left > 0 ? left : 0));
    }
  }, [taskHours, hoursWorked]);

  // Helper: Convert HH:MM:SS to seconds
  const convertTimeToSeconds = (time) => {
    const [h, m, s] = time.split(':').map(Number);
    return h * 3600 + m * 60 + s;
  };

  // Helper: Format seconds to HH:MM:SS
  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      empId,
      empName,
      designation,
      projectName,
      taskName,
      hoursWorked: hoursWorked || '00:00:00',
      projectStatus: projectStatus || 'inProgress',
      comments,
      surplusHours,
      overHours,
      hoursLeft,
    };
    fetch(`https://cleezoclass.com:8443/api/task-update`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setStatusMessage({ type: 'success', text: 'Task updated successfully!' });
          setPendingTasks(prevTasks => prevTasks.filter(task => task.addtask !== selectedTask));
          // Reset selected task

          fetchRecentTaskDetails(empId);
        } else {
          setStatusMessage({ type: 'error', text: data.message });
        }
      })
      .catch(err => {
        console.error('Network error:', err);
        setStatusMessage(`{ type: 'error', text: Network error: ${err.message} }`);
      });
  };
  const handleTaskChange = (e) => {
    const selectedTaskName = e.target.value;
    setSelectedTask(selectedTaskName);

    // Find the selected task in the pendingTasks array
    const selectedTaskData = pendingTasks.find((task) => task.addtask === selectedTaskName);

    if (selectedTaskData) {
      setProjectName(selectedTaskData.projecttitle); // Update the project name
    } else {
      setProjectName(""); // Reset project name if no task is selected
    }
  };
  const fetchRecentTaskDetails = (empId) => {
    const cacheBuster = new Date().getTime();
    fetch(`https://cleezoclass.com:8443/api/project-task-details?empId=${empId}&_=${cacheBuster}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          const task = data.task;
          setProjectName(task.projectName || '');
          setTaskName(task.taskName || '');
          setStartTime(task.starttime || '00:00:00');
          setEndTime(task.endtime || '00:00:00');
          setTaskHours(task.taskHours || '00:00:00');
          setSurplusHours(task.surplusHours || '00:00:00');
          setOverHours(task.overrunHours || '00:00:00');
          setHoursLeft(task.hoursLeft || '00:00:00');
          setTaskAssigned(true);
          setStatusMessage({ type: 'success', text: 'Today task!' });
        } else {
          setStatusMessage({ type: 'info', text: 'No task assigned for this employee.' });
          setTaskAssigned(false);
        }
      })
      .catch(err => {
        console.error('Error fetching task details:', err);
        setStatusMessage({ type: 'error', text: 'Error fetching project details' });
      });
  };

  return (
    <div className="container">
      <div className='task-update-form-container'>
        <div className='task-update-form-content'>
          <form onSubmit={handleSubmit} className="task-update-form">
            {/* Row 1: Employee Details */}
            <div className="task-update-row">
              <div className="task-update-form-group">
                <label>Emp Id:</label>
                <input type="text" value={empId} readOnly />
              </div>
              <div className="task-update-form-group">
                <label>Emp Name:</label>
                <input type="text" value={empName} readOnly />
              </div>
              <div className="task-update-form-group">
                <label>Designation:</label>
                <input type="text" value={designation} readOnly />
              </div>
            </div>

            {/* Row 2: Project & Task Info */}
            <div className="task-update-row">
              <div className="task-update-form-group">
                <label>Project Name:</label>
                <input type="text" value={projectName} readOnly />
              </div>
              <div className="task-update-form-group">
                <label>Task Name:</label>
                <select
                  value={selectedTask}
                  onChange={handleTaskChange}
                  onFocus={(e) => e.target.blur()} // Prevents immediate selection without showing dropdown
                >
                  {pendingTasks.length === 0 ? (
                    <option disabled>No tasks available</option>
                  ) : (
                    pendingTasks.map((task, index) => {
                      // Display symbols in the dropdown but not in the selected option
                      const displayText = index === 0 ? `✔️ ${task.addtask}` : `⏳ ${task.addtask}`;

                      return (
                        <option key={task.id} value={task.addtask}>
                          {selectedTask === task.addtask ? task.addtask : displayText}
                        </option>
                      );
                    })
                  )}
                </select>
              </div>
              <div className="task-update-form-group">
                <label>Task Hours:</label>
                <input type="text" value={taskHours} readOnly />
              </div>
            </div>

            {/* Row 3: Hours Worked, Surplus Hours, and Over Hours */}
            {taskAssigned && (
              <div className="task-update-row">
                <div className="task-update-form-group">
                  <label>Hours Worked:</label>
                  <input
                    type="time"
                    step="1"
                    value={hoursWorked}
                    onChange={(e) => setHoursWorked(e.target.value)}
                    required
                  />
                </div>
                <div className="task-update-form-group">
                  <label>Surplus Hours:</label>
                  <input type="text" value={surplusHours} readOnly />
                </div>
                <div className="task-update-form-group">
                  <label>Over Hours:</label>
                  <input type="text" value={overHours} readOnly />
                </div>
              </div>
            )}

            {/* Row 4: Hours Left, Project Status, and Comments */}
            <div className="task-update-row status-comments">
              <div className="task-update-form-group hours-left">
                <label>Hours Left:</label>
                <input type="text" value={hoursLeft} readOnly />
              </div>
              <div className="task-update-form-group project-status">
                <label>Project Status:</label>
                <select
                  value={projectStatus}
                  onChange={(e) => setProjectStatus(e.target.value)}
                  required
                >
                  <option value="">Select Project Status</option>
                  <option value="completed">Completed</option>
                  <option value="inProgress">In Progress</option>
                  <option value="delayed">Delayed</option>
                </select>
              </div>
              <div className="task-update-form-group comments">
                <label>Comments:</label>
                <input
                  type="text"
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                  placeholder="Provide comments"
                />
              </div>
            </div>
            {/* Unique Submit Button */}
            <button type="submit" className="task-update-submit-btn-unique">
              Submit
            </button>

            {statusMessage.text && (
              <div className={`status-message ${statusMessage.type}`}>
                {statusMessage.text}
              </div>
            )}


          </form>
        </div>

      </div>

    </div>

  );
};

export default TaskUpdateForm;